module.exports = __webpack_public_path__ + "static/media/connections.51fb427a.png";